
<app-loader></app-loader>
<div class="filter-model" [formGroup]="filterFormGroup">
  <div class="payment-option"><h4>Filter</h4><div class="custom-close" (click)="closeModal()"><img src="../../../../../assets/images/new-close.svg"></div></div>
  <hr />
  <div class="filter-body date-filter">
    <div *ngIf="errorMessage" class="bg-validation-error">{{errorMessage}}</div>
    <div class="date-end-date">
      <div class="inner-date date-outer">
        <label for="startdate">Start Date</label>
        <div class="custom-select2 custom-date-calender">
          <p-calendar 
          appendTo="body"
          #startDateOpen 
          placeholder="Select Date"
           [readonlyInput]="true" 
           [showTime]="false"
           formControlName="startdate"
           dateFormat="M dd, yy" 
           autofocus="false"
           (onSelect)="updateMinEndDate()"
           inputId="startDateInput"
           (keydown.enter)="applyFilter()"
           [appEnterKeyListener]="'start'"
          > 
          </p-calendar>
          <img [calendarOpener]="startDateOpen" src="assets/images/date-calender.png" alt="calender"/>
        </div>
      </div>
      <div class="inner-date date-outer">
        <label for="enddate">End Date</label>
        <div class="custom-select2 custom-date-calender">
          <p-calendar 
          appendTo="body"
          #endDate 
          placeholder="Select Date" 
          [readonlyInput]="true" 
          [showTime]="false" 
          formControlName="enddate" 
          dateFormat="M dd, yy" 
          [minDate]="minEndDate"
          inputId="endDateInput"
          (keydown.enter)="applyFilter()"
          [appEnterKeyListener]="'end'">
          </p-calendar>
          <img [calendarOpener]="endDate" src="assets/images/date-calender.png" alt="calender"/>
        </div>
      </div>
    </div>
    <div class="date-end-date  full-width-date">
      <div class="date-outer">
        <label for="parkingLot">Parking Location</label>
        <div class="custom-select2">
          <div class="filter-parking header-filter financials-filter">
            <p-multiSelect [options]="parkingLotByStatesListWithAll" formControlName="parkingLot" appendTo="body"
                optionLabel="name" optionValue="id" [defaultLabel]="'Select Parking Locations'" [autoZIndex]="true"> 
            </p-multiSelect>
            <img src="assets/images/fill-dropdown.svg" alt=""/>
        </div>
        <div
          *ngIf="filterFormGroup.get('parkingLot')?.hasError('required')  && (filterFormGroup.get('parkingLot')?.dirty || filterFormGroup.get('parkingLot')?.touched)">
          <div class="validation-error"> This field is required*</div>
        </div>
        </div>
      </div>
    </div>
    <div class="date-end-date">
      <div class="inner-date date-outer">
        <label for="invoiceNumber">Invoice Number</label>
        <div class="custom-select2 custom-date-calender">
          <input id="invoiceNumber" (keypress)="onlyNumberInputs($event)" type="text" placeholder="Enter invoice number" pInputText  formControlName="invoiceNumber"  maxlength="6"   (keydown.enter)="applyFilter()"/>
        </div>
      </div>

      <div class="inner-date date-outer">
        <label for="paymentStatus">Payment Status</label>
        <div class="custom-select2">
          <div class="filter-parking header-filter">
            <p-dropdown appendTo="body" [options]="selectPaymentStatus" (onChange)="onChangePaymentStatus($event)" formControlName="paymentStatus"
              placeholder="Select Payment Status" optionLabel="name" optionValue="id"
              optionValue="value"></p-dropdown><img src="assets/images/fill-dropdown.svg" alt=""/>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="save-btn">
    <p-button label="Apply Filter" (onClick)="applyFilter()"></p-button>
  </div>
</div>